var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_6619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.167 42.418H130.834V131.585H39.167V42.418Z",
    fill: "url(#paint0_radial_309_6619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1666 42.4166H130.834V131.584H39.1666V42.4166ZM35 135.75H135V38.25H35V135.75ZM100.5 73.0001C100.5 72.6668 100.625 72.5 101 72.5H107.542C107.875 72.5 108.042 72.625 108.042 73.0001V105.875C108.042 106.208 107.958 106.375 107.542 106.375H101.083C100.667 106.375 100.542 106.167 100.542 105.834V73.0001H100.5ZM100.042 63.5417C100.042 60.875 101.917 59.2917 104.292 59.2917C106.834 59.2917 108.542 61 108.542 63.5417C108.542 66.2916 106.75 67.7916 104.209 67.7916C101.792 67.7918 100.042 66.2916 100.042 63.5417ZM81.2917 86.7085C80.1252 82.0834 77.3753 72.0001 76.3334 67.125H76.2501C75.375 72.0001 73.1668 80.25 71.4169 86.7085H81.2917ZM69.7084 93.4586L66.4167 105.959C66.3334 106.292 66.2084 106.375 65.7918 106.375H59.6668C59.2501 106.375 59.1667 106.25 59.2501 105.75L71.0834 64.3332C71.2917 63.5833 71.4167 62.9166 71.5 60.875C71.5 60.5834 71.625 60.4584 71.8333 60.4584H80.5833C80.875 60.4584 80.9999 60.5417 81.0834 60.875L94.3334 105.833C94.4167 106.167 94.3334 106.375 94.0001 106.375H87.0833C86.75 106.375 86.5415 106.292 86.4584 106L83.0417 93.4586H69.7084Z",
    fill: "#FF7F18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_309_6619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3576 62.4004) scale(69.6668 67.4501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423325",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_6619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustLogo);
export default __webpack_public_path__ + "static/media/illustLogo.5df55a9483ad1d14e5342b0c2e3529f3.svg";
export { ForwardRef as ReactComponent };